import { render } from "./LootModal.vue?vue&type=template&id=55ded961&scoped=true"
import script from "./LootModal.vue?vue&type=script&lang=js"
export * from "./LootModal.vue?vue&type=script&lang=js"

import "./LootModal.vue?vue&type=style&index=0&id=55ded961&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ded961"]])

export default __exports__